<template>
  <div class="planNum_list">
    <GlobalInfoBar title="抽奖记录" />
    <GlobalForm
      :init-data="initData"
      :form-rules="formRules"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="80"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
    <el-form-item
      label-width="80px"
        class="el_from"
        label="选择时间:"
        slot="is_push_state_time"
        style="margin: 0"
      >
        <el-date-picker
          v-model="stateTime"
          type="daterange"
          value-format="timestamp"
          start-placeholder="开始日期"
          range-separator="~"
          end-placeholder="结束日期"
          clearable
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </el-form-item>
    </GlobalForm>
    <GlobalTable
      ref="GlobalTable"
      :columns="tableColumns"
      :data="tableData"
      :maxHeight="800"
      :currentPage="PlanIpageNum"
      :total="PlanItotal"
      :isPagination="false"
      @handleCurrentChange="handleCurrentChange"
    >
    <el-table-column label="核销时间" slot="write_time" align="center">
        <template slot-scope="{ row }">
         <span>{{ row.write_time||"--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作人员" slot="user_name" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.user_name||"--" }}</span>
        </template>
      </el-table-column>
    <el-table-column label="备注" slot="remarks" align="center">
        <template slot-scope="{ row }">
         <span>{{ row.remarks||"--" }}</span>
        </template>
      </el-table-column>
    <el-table-column label="核销状态" slot="write_off" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.write_off==1?'已核销':'待核销'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" slot="operat" align="center">
        <template slot-scope="{ row }">
          <el-button type="primary" size="small" @click="editPlan(row, 'edit')"  class="mr_sty"
            >核销</el-button
          >
        </template>
      </el-table-column>
    </GlobalTable>
    <el-dialog :visible.sync="visible" @closed="resetForm('ruleForm')" title="操作提示" width="600px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-form-item  label="备注" prop="remarks" label-width="100px">
          <el-input
            type="textarea"
            v-model="ruleForm.remarks"
            placeholder="请输入备注"
            :maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item class="el_form_r">
          <el-button type="primary" @click="submitForm('ruleForm', 'add')"
            >确认</el-button
          >
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { prizeLog ,prizeOff} from "../../../utils/request/users";
import _api from "@/utils/request";
export default {
  name: "planNum_list",
  data() {
    return {
      //弹窗参数
      visible: false,
      ruleForm: {
        remarks: "",
      },
      rules: {
        remarks: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      //列表
      GroupList: [
        {
          name: "今日",
          id: 1,
        },
        {
          name: "本月",
          id: 2,
        },
        {
          name: "今年",
          id: 3,
        },
      ],
      initData: null,
      formItemList: [ {
          key: "phone",
          type: "input",
          labelName: "手机号:",
          placeholder: "请输入手机号查询",
        },
        { slotName: "is_push_state_time" },
      ],
      stateTime: null,
      formRules: {},
      tableData: [],
      PlanItotal: 0,
      PlanIpageNum: 1,
      PlanIpageSize: 10,
      mold: 2,
      tableColumns: [
        { label: "奖品名称", prop: "prize_name" },
        { label: "手机号", prop: "phone" },
        { label: "抽奖时间", prop: "add_time" },
        { slotName: "write_time" },
        { slotName: "user_name" },
        { slotName: "remarks" },
        { slotName: "write_off" },
        { slotName: "operat" },
      ],
      log_id:''
    };
  },
  mounted() {
    this.PostPlanList();
  },
  methods: {
    //列表请求
    PostPlanList() {
      const params = {
        page: this.PlanIpageNum,
        limit: this.PlanIpageSize,
        phone: this.phone,
        beg_time: this.stateTime!==null?this.stateTime[0]:'',
        end_time: this.stateTime!==null?this.stateTime[1]:'',
      };
      prizeLog(params).then((res) => {
        console.log(res);
        this.tableData = res.data;
        this.PlanItotal = res.count;
      });
    },
    //翻页
    handleCurrentChange(val) {
      this.PlanIpageNum = val;
      this.PostPlanList();
    },
    handleChange(val) {
      console.log(val);
    },
    //搜索
    handleConfirm(data) {
      console.log(data, "data");
      this.phone=data.phone
      const params = {
        page: 1,
        limit: 10,
        phone: data.phone,
        beg_time: this.stateTime!==null?this.stateTime[0]:'',
        end_time: this.stateTime!==null?this.stateTime[1]:'',
      };
      prizeLog(params).then((res) => {
        console.log(res);
        this.tableData = res.data;
        this.PlanItotal = res.count;
      });
    },
    //发红包
    editPlan(row) {
      this.visible = true;
      this.log_id = row.log_id;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          prizeOff({log_id:this.log_id,...this.ruleForm}).then((res) => {
            console.log(res);
            if (res.code === 1) {
              this.visible = false;
              this.$message.success(res.msg);
              this.resetForm('ruleForm');
              this.PostPlanList();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.ruleForm={
        remarks: "",
      }
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.planNum_list {
  .tit_color {
    color: #0874e6;
    margin: 0 0 20px 0px;
  }
  /deep/ .el-form-item__label {
    width: 100px !important;
  }
  .el_form {
    /deep/ .el-form-item__label {
      width: 120px !important;
    }
    /deep/ .el-input__inner {
      width: 360px;
    }
    /deep/ .el-input {
      width: 360px;
    }
  }
  .el_form_r {
    float: right;
    margin-right: 80px;
  }
}
/deep/.el-textarea {
  width: 80%;
} 
.icon {
  cursor: pointer;
  margin-right: 20px;
}
</style>
